'use client';

import { c as _c } from "react/compiler-runtime";
import { ChainUtils } from '@morpho-org/blue-sdk';
import { InterfaceChainUtils, VaultToken, type YieldBearingToken } from '@morpho-org/dapp-core';
import { formatLongString } from '@morpho-org/morpho-ts';
import { InfoTooltip } from '@morpho-org/ui-v6/client';
import { ExternalLink } from '@morpho-org/ui-v6/server';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Button } from '@repo/ui';
import { ArrowDiagonalUp } from '@repo/ui/icons';
import Image from 'next/image';
import Link from 'next/link';
import { getVaultUrl } from '@/helpers/routing';
export interface NativeYieldProps {
  asset: YieldBearingToken | VaultToken;
  isVault?: boolean;
}
const formatRate = formatters.percent.default('-').trailingZero(false).digits(2).unit('%').max(10);
const NativeYield = t0 => {
  const $ = _c(33);
  const {
    asset,
    isVault
  } = t0;
  const isVaultToken = asset instanceof VaultToken;
  let t1;
  if ($[0] !== asset.symbol || $[1] !== asset.vault || $[2] !== isVaultToken) {
    t1 = isVaultToken ? formatLongString(asset.vault.name, 20) : formatLongString(asset.symbol ?? "", 8);
    $[0] = asset.symbol;
    $[1] = asset.vault;
    $[2] = isVaultToken;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const displayName = t1;
  const logoURI = isVaultToken ? asset.vault.underlyingAssetLogoURI : asset.logoURI;
  const yieldValue = isVaultToken ? asset.vault.netApy : asset.yield;
  let t2;
  if ($[4] !== asset.chain || $[5] !== asset.vault || $[6] !== isVaultToken) {
    t2 = isVaultToken ? getVaultUrl({
      identifier: InterfaceChainUtils.getIdentifierById(asset.chain.id),
      vaultAddress: asset.vault.address,
      vaultName: asset.vault.name
    }) : null;
    $[4] = asset.chain;
    $[5] = asset.vault;
    $[6] = isVaultToken;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const vaultUrl = t2;
  let t3;
  if ($[8] !== asset.name || $[9] !== asset.symbol || $[10] !== logoURI) {
    t3 = logoURI ? <Image src={logoURI} alt={asset.name ?? asset.symbol ?? "Native Yield token"} width={20} height={20} className="m-0.5" /> : <div className="bg-muted m-0.5 size-4 rounded-full" />;
    $[8] = asset.name;
    $[9] = asset.symbol;
    $[10] = logoURI;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== displayName) {
    t4 = <span className="text-2xs text-secondary-foreground">{displayName} Yield</span>;
    $[12] = displayName;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== asset.address || $[15] !== asset.chain || $[16] !== isVaultToken || $[17] !== vaultUrl) {
    t5 = isVaultToken && vaultUrl ? <Link href={vaultUrl}><Button variant="ghost" size="iconSm" aria-label="View vault"><ArrowDiagonalUp /></Button></Link> : <ExternalLink href={ChainUtils.getExplorerAddressUrl(asset.chain.id, asset.address)}><Button variant="ghost" size="iconSm" aria-label="View on explorer"><ArrowDiagonalUp /></Button></ExternalLink>;
    $[14] = asset.address;
    $[15] = asset.chain;
    $[16] = isVaultToken;
    $[17] = vaultUrl;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== isVault) {
    t6 = !isVault && <InfoTooltip tooltipContent={<>This APY applies only to the collateral and doesn't impact the borrowing rate.</>} />;
    $[19] = isVault;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
    t7 = <div className="gap-2xs flex items-center leading-none">{t3}{t4}{t5}{t6}</div>;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== yieldValue) {
    t8 = formatRate.of(yieldValue);
    $[26] = yieldValue;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t8) {
    t9 = <span className="text-2xs text-secondary-foreground">{t8}</span>;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t7 || $[31] !== t9) {
    t10 = <div className="flex min-h-8 items-center justify-between">{t7}{t9}</div>;
    $[30] = t7;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  return t10;
};
export default NativeYield;